import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/entiyInfo/honer.png'


const _withScopeId = n => (_pushScopeId("data-v-1ece4377"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "box-box" }
const _hoisted_3 = { class: "informbox" }
const _hoisted_4 = { class: "inform flex f-d" }
const _hoisted_5 = { class: "chooseinform flex j-s-b" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "idBox" }
const _hoisted_8 = { class: "contentbox flex f-d j-s-e" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "iformContent flex j-c a-c" }
const _hoisted_11 = {
  key: 0,
  class: "dialogbox flex j-s-e a-s"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { style: {"width":"4rem","font-size":"1.3rem"} }, "标题:", -1))
const _hoisted_13 = {
  key: 1,
  class: "dialogbox flex j-s-e a-s"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { style: {"width":"4rem","font-size":"1.3rem"} }, "内容:", -1))
const _hoisted_15 = {
  key: 2,
  class: "dialogbox flex j-s-e a-s"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { style: {"width":"4rem","font-size":"1.3rem"} }, "配图:", -1))
const _hoisted_17 = { class: "picture" }
const _hoisted_18 = ["src"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"lightgray"} }, "上传荣誉配图", -1))
const _hoisted_20 = ["accept"]
const _hoisted_21 = {
  key: 3,
  class: "title-team"
}
const _hoisted_22 = {
  key: 4,
  class: "telbox flex j-s-e a-s"
}
const _hoisted_23 = { class: "country flex a-c j-c" }
const _hoisted_24 = {
  key: 5,
  class: "chooseBox flex a-c j-c"
}
const _hoisted_25 = { class: "buttonList flex j-s-e a-c warp" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "dialog-footer" }
const _hoisted_28 = { class: "dialog-footer" }

import { ArrowRight } from "@element-plus/icons-vue";
import { onMounted, reactive, ref, watch } from "vue";
import Brief from "@/components/EntiyInfo/Brief.vue";
import Honor from "@/components/EntiyInfo/Honor.vue";
import Team from "@/components/EntiyInfo/Team.vue";
import { DefaultWebServiceFactory } from "@/services/webapi/DefaultWebServiceFactory";
import CheckType from "@/utils/CheckType";
import { BasicReview } from "@/services/datatype/ipsphere/review/BasicReview";
import { ReviewType } from "@/services/datatype/ipsphere/review/ReviewType";
import {
  OSSCredentialProvider,
  OssTokenConsumer,
} from "@/services/util/oss/OSSCredentialProvider";
import { OSSFederationToken } from "@/services/util/oss/OSSFederationToken";
import OSS from "ali-oss";
import UserTools from "@/services/session/UserTools";
import { EntityInfo } from "@/services/datatype/entity/EntityInfo";
import { ElMessage, ElMessageBox } from "element-plus";
// import Video from "@/components/talkMessage/Video.vue";
import IssueUtils from "@/utils/IssueUtils";
import { useRoute } from "vue-router";
import { PageBlockAccessSpec } from "@/services/datatype/paging/PageBlockAccessSpec";
import { UserDetails } from "@/services/datatype/entity/user/UserDetails";
import entiyinfo from "@/api/entiyinfo";
// import { UserInfoTabType } from "@/services/datatype/entity/user/UserInfoTabType";

export default /*#__PURE__*/_defineComponent({
  __name: 'LawFirmView',
  setup(__props) {

const route = useRoute();
const activeIndex = ref<number>(1);
const chooseList = reactive([
  {
    id: 1,
    title: "律所信息",
    content: "律所信息维护",
  },
  {
    id: 2,
    title: "公司荣誉",
    content: "律所荣誉发布",
  },
  {
    id: 3,
    title: "团队维护",
    content: "律所团队维护",
  },
]);
const honer = reactive({
  title: "",
  description: "",
  picture: "",
});
const phoneNumber = ref<number | string>();

const accept = ref<string>("");
const EntiyInfoDialogState = ref<boolean>(false);
const honorList = reactive([]);
const teamList = reactive([]);
const telList = [
  {
    country: "加拿大",
    num: "1",
  },
  {
    country: "美国",
    num: "1",
  },
  {
    country: "英国",
    num: "44",
  },
  {
    country: "中国",
    num: "86",
  },
];
const positionList = reactive([
  { name: "主任", roleType: 20 },
  { name: "副主任", roleType: 25 },
  { name: "高级合伙人", roleType: 26 },
  { name: "合伙人", roleType: 27 },
  { name: "律师", roleType: 28 },
  { name: "见习律师", roleType: 29 },
]);

// {
//     logo: require("../../assets/images/entiyInfo/honer.png"),
//     position: "威威i威威i欸额我i欸我",
//     keywords: ["123123", "123123", "123123"],
//     description: "dwftfdaufduyfwayudfaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
// },

const positionIndex = ref<number>(20);
const telIndex = ref<number>(86);
// 切换电话+86
const changeCountry = (num) => {
  telIndex.value = num;
};
const choosePostion = (roleType) => {
  positionIndex.value = roleType;
};
const clearHonor = () => {
  honer.title = "";
  honer.description = "";
  honer.picture = "";
};

const issuehonor = () => {
  EntiyInfoDialogState.value = true;
};
const addPerson = () => {
  EntiyInfoDialogState.value = true;
};
const chooseInform = (id: number) => {
  activeIndex.value = id;
};
// 发布 activeIndex == 2 上传荣誉 3 增加成员
const issue = () => {
  // EntiyInfoDialogState.value = false;
  if (activeIndex.value == 2) {
    const basicReview = new BasicReview();
    basicReview.reviewType = ReviewType.HONOUR;
    basicReview.title = honer.title;
    basicReview.targetEntityId = (
      UserTools.getLoginSystemSuppliedEntityInfo().entityDesc
        .additionalAttributes as UserDetails
    ).workerInfo.enterpriseInfo.entityId;
    let initiatorInfo = new EntityInfo();
    initiatorInfo.entityId = (
      UserTools.getLoginSystemSuppliedEntityInfo().entityDesc
        .additionalAttributes as UserDetails
    ).workerInfo.enterpriseInfo.entityId;
    basicReview.initiatorInfo = initiatorInfo;
    basicReview.description = honer.description;
    if (honer.picture && honer.picture.length > 0) {
      basicReview.imageUrls = [honer.picture];
    }
    entiyinfo.addBasicReview(basicReview as BasicReview).then((t) => {
      console.log(t);
      if (t) {
        clearHonor();
        ElMessage.success("发布成功");
        EntiyInfoDialogState.value = false;
        getHonorList();
      }
    });
  } else if (activeIndex.value == 3) {
    // const phoneTest =
    //   /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/;
    // if (phoneTest.test(String(phoneNumber.value))) {
    const targetId = (
      UserTools.getLoginSystemSuppliedEntityInfo().entityDesc
        .additionalAttributes as UserDetails
    ).workerInfo.enterpriseInfo.entityId;
    console.log(targetId);
    DefaultWebServiceFactory.getInstance()
      .getWebEnterpriseHomeService()
      .addMemeberByPhoneNumber(
        targetId,
        positionIndex.value,
        String(phoneNumber.value),
        null,
        null
      )
      .then((t) => {
        console.log(t);
        if (t) {
          ElMessage.success("添加成功");
          phoneNumber.value = "";
          EntiyInfoDialogState.value = false;
          positionIndex.value = 20;
          getTeamList();
        }
      })
      .catch((e) => {
        phoneNumber.value = "";
        ElMessage.error(e.errorMessage);
      });
  }
  // else {
  //   ElMessage.warning("请输入正确手机号");
  // }
};
const deleteMember = (e) => {
  console.log(e);
  ElMessageBox.confirm("确定删除该成员嘛", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    // type: 'warning'
  }).then(() => {
    const targetId = (
      UserTools.getLoginSystemSuppliedEntityInfo().entityDesc
        .additionalAttributes as UserDetails
    ).workerInfo.enterpriseInfo.entityId;
    console.log(e.roleType, e.id);
    DefaultWebServiceFactory.getInstance()
      .getWebEntityService()
      .deleteAssociation(targetId, e.roleType, e.id)
      .then((t) => {
        if (t.getResult()) {
          ElMessage.success("删除成功");
          getTeamList();
        } else {
          ElMessage.error(t.getError().getErrorMessage());
        }
      });
  });
};

const changeImg = () => {
  if (activeIndex.value == 2) {
    accept.value = "image/*";
    setTimeout(() => {
      (document.getElementsByClassName("file")[0] as HTMLInputElement).click();
    }, 100);
  }
};
const cancel = () => {
  if (activeIndex.value == 2) {
    clearHonor();
    EntiyInfoDialogState.value = false;
  }
};
const upload = async (e) => {
  const fileTarget: any = e.target;
  console.log(fileTarget.files);
  const tokenConsumer: OssTokenConsumer = async (
    token: OSSFederationToken
  ): Promise<void> => {
    if (token) {
      const client = new OSS({
        region: "oss-cn-hangzhou",
        accessKeyId: token.tempAK,
        accessKeySecret: token.tempSK,
        stsToken: token.securityToken,
        bucket: "gong-wei",
      });
      let fileList = [];
      for (const files of fileTarget.files) {
        fileList.push(files);
      }
      if (fileList.every((r) => CheckType.checkImgVideo(r.name))) {
        if (activeIndex.value == 2) {
          const fullFileName: string = IssueUtils.newFileName(
            token,
            fileList[0]
          );
          const result = await client.put(fullFileName, fileList[0]);
          honer.picture = IssueUtils.getResult(result);
        } else if (activeIndex.value == 3) {
          // 管理成员
        }
      } else {
        ElMessage.warning("请上传正确文件格式");
      }
      (document.getElementsByClassName("file")[0] as HTMLInputElement).value =
        null;
    }
  };
  OSSCredentialProvider.getInstance().getFederationToken(tokenConsumer);
};

const getHonorList = () => {
  honorList.splice(0, honorList.length);
  const pageSpec = new PageBlockAccessSpec();
  pageSpec.pageSize = 3;
  const targetEntityId = (
    UserTools.getLoginSystemSuppliedEntityInfo().entityDesc
      .additionalAttributes as UserDetails
  ).workerInfo.enterpriseInfo.entityId;
  entiyinfo.getHomeHonor(targetEntityId, true, pageSpec).then((t) => {
    console.log(t.data.getPageData());
    [...t.data.getPageData()].forEach((r) => {
      honorList.push({
        title: r.viewInfo.title,
        content: r.viewInfo.description,
        picture: r.viewInfo.imageUrls
          ? CheckType.isImg(r.viewInfo.imageUrls[0])
          : "",
      });
    });
  });
};
const getTeamList = () => {
  teamList.splice(0, teamList.length);
  const targetEntityId = (
    UserTools.getLoginSystemSuppliedEntityInfo().entityDesc
      .additionalAttributes as UserDetails
  ).workerInfo.enterpriseInfo.entityId;
  const pageSpec = new PageBlockAccessSpec();
  pageSpec.pageSize = 2;
  entiyinfo.getEmployeeByEnterpriseId(targetEntityId, pageSpec).then((t) => {
    console.log(t);
    [...t.data.getPageData()].forEach((r) => {
      teamList.push({
        name: r.entityName,
        description: r.description,
        keywords: r.keywords,
        logo: r.logoImgUrl
          ? CheckType.isImg(r.logoImgUrl)
          : require("@/assets/images/Talk/logo.jpg"),
        roleType: r.roleType,
        id: r.entityId,
      });
    });
    console.log(teamList);
  });
};

watch(route, () => {
  activeIndex.value = Number(route.query.id) + 1;
});
onMounted(() => {
  activeIndex.value = Number(route.query.id) + 1;
  getHonorList();
  getTeamList();
});

return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_breadcrumb, {
          "separator-icon": _unref(ArrowRight) as any
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_breadcrumb_item, { to: {path:'/layout/home'} as any }, {
              default: _withCtx(() => [
                _createTextVNode("首页")
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _createTextVNode("信息维护")
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(chooseList[chooseList.findIndex((r) => r.id == activeIndex.value)].title), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["separator-icon"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chooseList, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["choosebox flex j-c a-c", activeIndex.value == item.id ? 'active' : '']),
                key: item.id,
                onClick: ($event: any) => (chooseInform(item.id))
              }, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(item.id), 1),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("h1", _hoisted_9, _toDisplayString(item.title), 1),
                  _createElementVNode("h4", null, _toDisplayString(item.content), 1)
                ])
              ], 10, _hoisted_6))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_10, [
            (activeIndex.value == 1)
              ? (_openBlock(), _createBlock(Brief, { key: 0 }))
              : _createCommentVNode("", true),
            (activeIndex.value == 2)
              ? (_openBlock(), _createBlock(Honor, {
                  key: 1,
                  honorList: honorList,
                  onIssuehonor: issuehonor
                }, null, 8, ["honorList"]))
              : _createCommentVNode("", true),
            (activeIndex.value == 3)
              ? (_openBlock(), _createBlock(Team, {
                  key: 2,
                  onAddPerson: addPerson,
                  teamList: teamList,
                  onDeleteMember: _cache[0] || (_cache[0] = ($event: any) => (deleteMember($event)))
                }, null, 8, ["teamList"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      onClose: _cache[7] || (_cache[7] = ($event: any) => (activeIndex.value == 2 ? clearHonor() : clearHonor())),
      modelValue: EntiyInfoDialogState.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((EntiyInfoDialogState).value = $event)),
      title: activeIndex.value == 2 ? '新增荣誉' : '新增成员',
      width: "40%",
      center: ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_27, [
          _createVNode(_component_el_button, {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (cancel())),
            class: "cancel"
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("span", _hoisted_28, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (issue()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(activeIndex.value == 3 ? "确定" : "发布"), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (activeIndex.value == 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _hoisted_12,
              _withDirectives(_createElementVNode("textarea", {
                class: "input-issue",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((honer.title) = $event)),
                placeholder: "写下荣誉名称..."
              }, null, 512), [
                [_vModelText, honer.title]
              ])
            ]))
          : _createCommentVNode("", true),
        (activeIndex.value == 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _hoisted_14,
              _withDirectives(_createElementVNode("textarea", {
                class: "input-issue",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((honer.description) = $event)),
                placeholder: "晒晒自己的荣誉、行业资质..."
              }, null, 512), [
                [_vModelText, honer.description]
              ])
            ]))
          : _createCommentVNode("", true),
        (activeIndex.value == 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, [
                (honer.picture)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "picture1",
                      src: _unref(CheckType).isImg(honer.picture),
                      alt: ""
                    }, null, 8, _hoisted_18))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      class: "picture1",
                      src: _imports_0,
                      alt: "",
                      onClick: changeImg
                    })),
                _hoisted_19,
                _createElementVNode("input", {
                  type: "file",
                  hidden: "",
                  class: "file",
                  onChange: _cache[3] || (_cache[3] = (e) => upload(e)),
                  accept: accept.value
                }, null, 40, _hoisted_20)
              ])
            ]))
          : _createCommentVNode("", true),
        (activeIndex.value == 3)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_21, "请输入成员注册手机号:"))
          : _createCommentVNode("", true),
        (activeIndex.value == 3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_el_dropdown, { trigger: "click" }, {
                  dropdown: _withCtx(() => [
                    _createVNode(_component_el_dropdown_menu, null, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(telList, (item, index) => {
                          return _createVNode(_component_el_dropdown_item, {
                            "default-active": telIndex.value,
                            key: index,
                            onClick: ($event: any) => (changeCountry(item.num))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.country + item.num), 1)
                            ]),
                            _: 2
                          }, 1032, ["default-active", "onClick"])
                        }), 64))
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("span", null, [
                      _createElementVNode("h1", null, _toDisplayString("+" + telIndex.value), 1)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _withDirectives(_createElementVNode("input", {
                class: "input-tel",
                type: "tel",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((phoneNumber).value = $event)),
                placeholder: "请填写手机号"
              }, null, 512), [
                [_vModelText, phoneNumber.value]
              ])
            ]))
          : _createCommentVNode("", true),
        (activeIndex.value == 3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(positionList, (item2) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["choosebutton", positionIndex.value == item2.roleType ? 'positionActive' : '']),
                    key: item2.roleType,
                    onClick: ($event: any) => (choosePostion(item2.roleType))
                  }, _toDisplayString(item2.name), 11, _hoisted_26))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}
}

})